import type { ISegment } from "src/helpers/segmentFilterHook";
import type { BranchFilterItem } from "src/models/filterItem";

import type { FilterItem } from "@repo/models";

import { BaseController } from "./baseController";

const controller = import.meta.env.MODE === "development" ? "MVC/GridFilters" : "GridFilters";

export class GridFiltersController extends BaseController {
	static Get = BaseController.GetFn(controller);
	static GetFilterItems<T extends FilterItem = FilterItem>(action: string, filters?: ISegment) {
		return GridFiltersController.Get<T[]>(action, filters);
	}
	static getBrands(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetBrandsDyn", filters);
	}

	static getChannels(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetChannelsDyn", filters);
	}

	static getMarketers(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetMarketersDyn", filters);
	}

	static getStates(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetStatesDyn", filters);
	}

	static getAllStates() {
		return GridFiltersController.GetFilterItems<StateFilterItem>("GetAllStatesDyn");
	}

	static getBranches(filters?: ISegment) {
		return GridFiltersController.GetFilterItems<BranchFilterItem>("GetBranchesDyn", filters);
	}

	static getReps(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetRepsDyn", filters);
	}

	static getMachines(filters?: ISegment) {
		return GridFiltersController.GetFilterItems("GetMachinesDyn", filters);
	}
}

export interface StateFilterItem extends FilterItem {
	code: string;
}
